import axios from "axios"

function getApiBaseUrl() {
  const rawBaseUrl =
    import.meta.env.VITE_API_BASE_URL || "http://127.0.0.1:8000"

  const cleanBaseUrl = rawBaseUrl.replace(/\/+$/, "")

  if (cleanBaseUrl.endsWith("/api")) {
    return cleanBaseUrl
  }

  return `${cleanBaseUrl}/api`
}

function safeJsonParse(value, fallback = {}) {
  try {
    return JSON.parse(value || "{}")
  } catch {
    return fallback
  }
}

const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
})

api.interceptors.request.use(
  (config) => {
    const user = safeJsonParse(localStorage.getItem("kongosys_user"), {})

    const userId =
      localStorage.getItem("kongosys_user_id") ||
      user.id ||
      ""

    const role =
      localStorage.getItem("kongosys_role") ||
      user.role ||
      ""

    const companyId =
      localStorage.getItem("kongosys_company_id") ||
      user.company_id ||
      "1"

    const organizationId =
      localStorage.getItem("kongosys_organization_id") ||
      user.organization_id ||
      ""

    const organizationCode =
      localStorage.getItem("kongosys_organization_code") ||
      user.organization_code ||
      ""

    const storeId =
      localStorage.getItem("kongosys_store_id") ||
      user.store_id ||
      ""

    const warehouseId =
      localStorage.getItem("kongosys_warehouse_id") ||
      user.warehouse_id ||
      ""

    config.headers["x-kongosys-user-id"] = String(userId)
    config.headers["x-user-id"] = String(userId)
    config.headers["X-User-Id"] = String(userId)

    config.headers["x-kongosys-role"] = String(role)
    config.headers["x-user-role"] = String(role)
    config.headers["x-role"] = String(role)
    config.headers["X-Role"] = String(role)

    config.headers["x-kongosys-company-id"] = String(companyId)
    config.headers["x-company-id"] = String(companyId)
    config.headers["X-Company-Id"] = String(companyId)

    config.headers["x-kongosys-organization-id"] = String(organizationId)
    config.headers["x-organization-id"] = String(organizationId)
    config.headers["X-Organization-Id"] = String(organizationId)

    config.headers["x-kongosys-organization-code"] = String(organizationCode)
    config.headers["x-organization-code"] = String(organizationCode)

    config.headers["x-kongosys-store-id"] = String(storeId)
    config.headers["x-store-id"] = String(storeId)
    config.headers["X-Store-Id"] = String(storeId)

    config.headers["x-kongosys-warehouse-id"] = String(warehouseId)
    config.headers["x-warehouse-id"] = String(warehouseId)
    config.headers["X-Warehouse-Id"] = String(warehouseId)

    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status

    if (status === 401) {
      localStorage.removeItem("kongosys_user")
      localStorage.removeItem("kongosys_user_id")
      localStorage.removeItem("kongosys_full_name")
      localStorage.removeItem("kongosys_role")
      localStorage.removeItem("kongosys_role_id")
      localStorage.removeItem("kongosys_company_id")
      localStorage.removeItem("kongosys_organization_id")
      localStorage.removeItem("kongosys_organization_code")
      localStorage.removeItem("kongosys_organization_name")
      localStorage.removeItem("kongosys_organization_type")
      localStorage.removeItem("kongosys_store_id")
      localStorage.removeItem("kongosys_store_code")
      localStorage.removeItem("kongosys_store_name")
      localStorage.removeItem("kongosys_warehouse_id")
      localStorage.removeItem("kongosys_warehouse_code")
      localStorage.removeItem("kongosys_warehouse_name")
    }

    return Promise.reject(error)
  }
)

export default api